export default function headerBio(clickedElement) {

    const headerBio = document.querySelector('.header-bio');
    const personCardWrapper = document.querySelector('.header-bio__left-side');
    const bioText = clickedElement.dataset.bio;
    const headerBioTextWrapper = document.querySelector(".header-bio__right-side-text-wrapper");

    // document.documentElement.classList.add('no-scroll');
    headerBio.classList.add('active');

    let clonedElement = clickedElement.parentElement.parentElement.parentElement.cloneNode(true);

    while( personCardWrapper.hasChildNodes() ){
        personCardWrapper.removeChild(personCardWrapper.lastChild);
    }

    personCardWrapper.appendChild(clonedElement);
    personCardWrapper.querySelector('.card-person').classList.add('card-person--header-bio');
    const socialWrapper = personCardWrapper.querySelector('.card-person__social-wrapper');
    const button = personCardWrapper.querySelector(".card-person__button");

    if (socialWrapper) {
        socialWrapper.classList.add('active');
    }

    if (button) {
        button.remove();
    }

    headerBioTextWrapper.innerHTML = bioText;
}